import React from "react";

const MARKERS = [
  { char: "*", tag: "strong" as const },
  { char: "_", tag: "em" as const },
  { char: "~", tag: "del" as const },
];
const VAR_RE = /^\{\{(\d+)\}\}/;

const STARTS_WITH_VARIABLE = /^[\s.,!?;:()"'«»-]*\{\{\s*\d+\s*\}\}/;
const ENDS_WITH_VARIABLE = /\{\{\s*\d+\s*\}\}[\s.,!?;:()"'«»-]*$/;

/** Meta refuses a body that opens or closes on a variable; the server enforces it. */
export const bodyEdgesOnVariable = (body: string): boolean => {
  const text = body.trim();
  return STARTS_WITH_VARIABLE.test(text) || ENDS_WITH_VARIABLE.test(text);
};

export const renderWhatsappText = (text: string): React.ReactNode => {
  const walk = (input: string, keyBase: string): React.ReactNode[] => {
    const nodes: React.ReactNode[] = [];
    let buffer = "";
    let i = 0;
    let n = 0;
    const flush = () => {
      if (buffer) {
        nodes.push(
          <React.Fragment key={`${keyBase}-t${n++}`}>{buffer}</React.Fragment>
        );
        buffer = "";
      }
    };
    while (i < input.length) {
      const varMatch = VAR_RE.exec(input.slice(i));
      if (varMatch) {
        flush();
        nodes.push(
          <span
            key={`${keyBase}-v${n++}`}
            className="rounded bg-gray-200 px-1 text-xs font-medium text-gray-600"
          >
            {`{{${varMatch[1]}}}`}
          </span>
        );
        i += varMatch[0].length;
        continue;
      }
      const current = input[i];
      const marker = MARKERS.find((m) => current === m.char);
      if (marker) {
        const close = input.indexOf(marker.char, i + 1);
        if (close > i + 1) {
          flush();
          const Tag = marker.tag;
          nodes.push(
            <Tag key={`${keyBase}-f${n++}`}>
              {walk(input.slice(i + 1, close), `${keyBase}-f${n}`)}
            </Tag>
          );
          i = close + 1;
          continue;
        }
      }
      buffer += input[i];
      i++;
    }
    flush();
    return nodes;
  };
  return walk(text || "", "w");
};
